var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,0.1c-6.6,0-12,5.4-12,12.1s5.4,12.1,12,12.1s12-5.4,12-12.1c0-3.2-1.3-6.3-3.5-8.6 C18.3,1.3,15.3,0.1,12.1,0.1z M12.1,22.2c-5.5,0-10-4.5-10-10.1S6.6,2,12.1,2s10,4.5,10,10.1S17.6,22.2,12.1,22.2z M16.1,14.5 c0.1,1.2-0.3,2.4-1.2,3.2C14,18.2,13,18.4,12,18.4c-1,0.1-2.1-0.2-3-0.7c-0.7-0.5-1.2-1.4-1.1-2.4h2c0,0.4,0.2,0.8,0.5,0.9 c0.5,0.2,1,0.3,1.5,0.2c0.6,0.1,1.2-0.1,1.7-0.4c0.3-0.4,0.5-0.9,0.4-1.4c0-0.4,0-0.8-0.1-1.2c-0.1-0.2-0.3-0.4-0.5-0.5 c-0.5-0.1-1-0.1-1.5-0.1h-1.7V11h1.7c0.4,0,0.7,0,1.1-0.1c0.2,0,0.4-0.1,0.6-0.3c0.3-0.4,0.4-0.8,0.4-1.3c0-0.3,0-0.6-0.1-0.9 c0-0.2-0.2-0.4-0.3-0.5c-0.5-0.2-1-0.3-1.6-0.3s-1.1,0.1-1.7,0.3C10,8.4,9.8,8.7,9.9,9h-2C7.8,8,8.3,7,9.2,6.5C10,6.1,11,6,11.9,6 c1.1-0.1,2.2,0.2,3.2,0.8c0.6,0.7,1,1.7,0.9,2.6c0,0.5,0,1.1-0.2,1.6c-0.2,0.4-0.5,0.7-0.9,0.9c0.4,0.2,0.7,0.5,0.9,0.9 C16,13.3,16.1,13.9,16.1,14.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStep3);
export default __webpack_public_path__ + "static/media/ico-step3.50d6406f61e26aa09def5ce6f297a28d.svg";
export { ForwardRef as ReactComponent };